export function formatTokensCompact(count: number): string {
  if (count >= 1000) {
    return `${(count / 1000).toFixed(1)}k`;
  }
  return String(count);
}

export function formatTokensPl(count: number): string {
  return count.toLocaleString("pl-PL").replace(/[  ]/g, " ");
}
